"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _UserContext = _interopRequireDefault(require("@micado-digital/react-ui/context/UserContext"));
var _useLink = _interopRequireDefault(require("@micado-digital/react-link/hooks/useLink"));
var _fireCustomEvent = _interopRequireDefault(require("@micado-digital/react-ui/utils/fireCustomEvent"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Logout = () => {
  var _useContext;
  const setUserData = (_useContext = (0, _react.useContext)(_UserContext.default)) === null || _useContext === void 0 ? void 0 : _useContext[1];
  const navigate = (0, _useLink.default)();
  (0, _react.useEffect)(() => {
    localStorage.removeItem("logintoken");
    localStorage.removeItem("mco-shop-user-groups");
    const logout = async () => {
      const {
        REACT_APP_PATH
      } = process.env;
      const formData = new FormData();
      formData.append("jsonResponse", 1);
      await fetch(REACT_APP_PATH + "/logout.internal", {
        method: "POST",
        body: formData
      });
      await (0, _fireCustomEvent.default)("logout", {
        value: true
      });
      localStorage.removeItem("logintoken");
      setUserData({});
      navigate("/");
    };
    logout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};
var _default = exports.default = Logout;